import contactPreferencesForm from './contact-preferences.html';
import CommonApp from '../../app.js';

var ContactPreferencesController = function() {
    var self = this;
};

CommonApp.module.component('nsContactPreferences', {
    template: contactPreferencesForm,
    bindings: {
        contactPreferences: '=',
        translations: '=',
    },
    controller: ContactPreferencesController,
    controllerAs: 'ctrl'
});



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/angular/components/contact-preferences/contact-preferences.js
// module id = 243
// module chunks = 0